module.exports = __webpack_public_path__ + "static/img/1.241ac3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/eng/1.png
// module id = rVp6
// module chunks = 0